import React from "react";
import { useCursor } from "../providers/CursorContext";
import { useTheme } from "../providers/ThemeContext";

export const CustomCursor: React.FC = () => {
  const { position, cursorSize, isHover } = useCursor();
  const { theme } = useTheme();

  // If cursorSize is 0, it means cursor exited the window, so hide it.
  if (cursorSize === 0) return null;

  const colorBase = theme === "dark" ? "255, 255, 255" : "0, 0, 0";
  const opacityNormal = "1";
  const opacityHover = "0.2";
  
  const cursorColor = isHover ? `rgba(${colorBase}, ${opacityHover})` : `rgba(${colorBase}, ${opacityNormal})`;

  return (
    <>
      {/* Hide standard cursor globally via styling inside component */}
      <style>{`
        @media (pointer: fine) {
          html, body, button, a, [role="button"] {
            cursor: none !important;
          }
        }
      `}</style>

      {/* Custom Cursor Wrapper */}
      <div
        className="fixed pointer-events-none z-50 hidden md:block"
        style={{
          top: position.y,
          left: position.x,
          transform: "translate(-50%, -50%)",
          filter: theme === "dark"
            ? "drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.8))"
            : "drop-shadow(0px 0px 2px rgba(255, 255, 255, 0.8))",
        }}
      >
        {/* Outer Circle Container */}
        <div
          className="border rounded-full flex items-center justify-center transition-all duration-200 ease-out"
          style={{
            width: cursorSize,
            height: cursorSize,
            borderColor: cursorColor,
            padding: isHover ? "0px" : `${cursorSize * 0.25}px`,
          }}
        >
          {/* Inner Circle Dot */}
          <div
            className="w-full h-full rounded-full transition-all duration-200 ease-out"
            style={{
              backgroundColor: cursorColor,
            }}
          />
        </div>
      </div>
    </>
  );
};
